import { render, staticRenderFns } from "./productBaseMarginRate.vue?vue&type=template&id=66338056&scoped=true"
import script from "./productBaseMarginRate.vue?vue&type=script&lang=js"
export * from "./productBaseMarginRate.vue?vue&type=script&lang=js"
import style0 from "./productBaseMarginRate.vue?vue&type=style&index=0&id=66338056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66338056",
  null
  
)

export default component.exports